import { Box } from '@mui/material';
import LoadingIndicator from './LoadingIndicator';
import React from 'react';

/**
 * A loading indicator to show when the whole app is loading and not just part of a page
 */
const AppLoadingIndicator = (): JSX.Element => {
  return (
    <Box sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <LoadingIndicator />
    </Box>
  );
};

export default AppLoadingIndicator;
